import React from "react";

const InfoSection1 = () => {
  return (
    <section className="info1-section" id="impact">
  <h2 className="info1-title">
    Gemeinsamer Impact für <br/><span className="highlight">Unternehmen</span> & <span className="highlight">Talente</span>
  </h2>
  <div className="info1-underline" />
  <p className="info1-subtitle">
    Qlance schafft echten Mehrwert – für Organisationen mit Innovationswillen und Talente mit Ambitionen.
  </p>
      <div className="info1-cards">
        {/* Unternehmen */}
        <div className="info1-card">
          <h3>Für Unternehmen</h3>
          <ul className="info1-list">
  <li> Engagierte Talente mit aktuellem Know-how & innovativem Mindset</li>
  <li> Flexible Ergänzung interner Ressourcen – genau dann, wenn gebraucht</li>
  <li> Ideal für: kurzfristige Engpässe, Innovationsprojekte, langfristige Unterstützung</li>
  <li> Zukunftssichere, effiziente Lösung durch projektbasierte Zusammenarbeit</li>
</ul>

        </div>

        {/* Studierende */}
        <div className="info1-card">
          <h3>Für Talente</h3>
<ul className="info1-list">
  <li> Praktische Erfahrung durch projektbasiertes Arbeiten bei führenden Unternehmen</li>
  <li> Flexibler Einstieg als Freelancer – unabhängig von Werkstudenten- oder Festanstellung</li>
  <li> Passende Projekte für Praxissemester, Projektarbeiten oder erste Berufserfahrung</li>
  <li> Direkter Zugang zu spannenden Aufgaben & professioneller Karriereaufbau</li>
</ul>

        </div>
      </div>
    </section>
  );
};

export default InfoSection1;
